import { parse } from 'querystring';
import { NotificationModel } from '../../components/AccountNotifications';
import { ActionType, IntegrationStatus, IntegrationType } from '../../../../lib/api/account-linking/types';
import { CreateUniqueId } from './Identifiers';
import { TFunction } from 'i18next';

interface AccountLinkingResponse {
  actionableAction: boolean;
  integrationType?: IntegrationType;
  slug?: string;
  success?: boolean;
  accountStatus?: IntegrationStatus;
  action?: ActionType;
  accountId?: string;
}

export function AccountLinkingMessageHelper(
  action: ActionType,
  success: boolean,
  t: TFunction<string, undefined>,
  _errorCode?: number
) {
  switch (action) {
    case 'Configure':
      return success
        ? t(`ACCOUNT_${action.toUpperCase()}_SUCCESS`, { defaultValue: `Account updated` })
        : t(`ACCOUNT_${action.toUpperCase()}_FAIL`, { defaultValue: `We were unable to update your account` });

    case 'Link':
    case 'Install':
      return success
        ? t(`ACCOUNT_${action.toUpperCase()}_SUCCESS`, { defaultValue: `You have successfully linked your account` })
        : t(`ACCOUNT_${action.toUpperCase()}_FAIL`, { defaultValue: `We were unable to link your account` });

    case 'Delete':
      return success
        ? t(`ACCOUNT_${action.toUpperCase()}_SUCCESS`, { defaultValue: `Account deleted` })
        : t(`ACCOUNT_${action.toUpperCase()}_FAIL`, { defaultValue: `We were unable to delete your account` });

    case 'Renew':
      return success
        ? t(`ACCOUNT_${action.toUpperCase()}_SUCCESS`, { defaultValue: `Account successfully renewed` })
        : t(`ACCOUNT_${action.toUpperCase()}_FAIL`, { defaultValue: `We were unable to renew your account` });

    default:
      return success
        ? t(`ACCOUNT_DEFAULT_ACTION_SUCCESS`, { defaultValue: `Success` })
        : t(`ACCOUNT_DEFAULT_ACTION_FAIL`, { defaultValue: `Failed` });
  }
}

export function AccountLinkingResponseHelper(url: string): AccountLinkingResponse {
  //?IntegrationSlug=ebay&IntegrationType=Marketplace&Success=True&Action=Link&AccountId=EB61552&AccountStatus=Active
  //?IntegrationSlug=temu&IntegrationType=Marketplace&Success=True&Action=Install&AccountStatus=Active

  const u = (url || window.location.href).split('?')[1];
  if (!u || u.indexOf('Action=') == -1) {
    return { actionableAction: false };
  }

  const parsed = parse(u);

  const accountLinkingResponse = {
    actionableAction: true,
    accountId: parsed.AccountId as string,
    accountStatus: parsed.AccountStatus as IntegrationStatus,
    action: parsed.Action as ActionType,
    integrationType: parsed.IntegrationType as IntegrationType,
    slug: parsed.IntegrationSlug as string,
    success: ((parsed.Success as string) || '').toLowerCase() === 'true'
  };
  return accountLinkingResponse;
}

export function AccountActionResponseHelper(
  action: ActionType,
  integrationType: IntegrationType,
  integrationSlug: string,
  success: boolean,
  accountId: string,
  configRequired: boolean,
  t: TFunction<string, undefined>
): NotificationModel {
  return {
    color: success ? 'success' : 'error',
    note: AccountLinkingMessageHelper(action, success, t),
    id: CreateUniqueId(),
    integrationSlug: integrationSlug,
    integrationType: integrationType,
    accountId: accountId,
    actions: [],
    showClose: true,
    configRequired: configRequired
  };
}
